import { Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ErrorAlertProps {
  message: string;
  onDismiss?: () => void;
  onRetry?: () => void;
  showRetry?: boolean;
}

export default function ErrorAlert({ message, onDismiss, onRetry, showRetry = false }: ErrorAlertProps) {
  const { t } = useTranslation();
  
  // メッセージが翻訳キー（api.error.*で始まる）の場合は翻訳する
  const displayMessage = message.startsWith('api.error.') 
    ? t(message, { defaultValue: message })
    : message;
  
  return (
    <Alert variant="danger" dismissible={!!onDismiss} onClose={onDismiss}>
      <Alert.Heading>{t('common.error_occurred', { defaultValue: 'エラーが発生しました' })}</Alert.Heading>
      <p>{displayMessage}</p>
      {showRetry && onRetry && (
        <div className="mt-3">
          <Button variant="outline-danger" size="sm" onClick={onRetry}>
            {t('common.retry', { defaultValue: '再試行' })}
          </Button>
        </div>
      )}
    </Alert>
  );
}

